import { render } from "./DiscountDecisionRequestModal.vue?vue&type=template&id=e5c101d4&scoped=true"
import script from "./DiscountDecisionRequestModal.vue?vue&type=script&lang=js"
export * from "./DiscountDecisionRequestModal.vue?vue&type=script&lang=js"

import "./DiscountDecisionRequestModal.vue?vue&type=style&index=0&id=e5c101d4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5c101d4"]])

export default __exports__